import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="shine"
export default class extends Controller {
    static values = {
        strength: { type: Number, default: 1 },
        debug: { type: Boolean, default: false }
    }

    connect() {
        this.boundMove = this.onMove.bind(this)
        this.boundLeave = this.onLeave.bind(this)
        this.boundEnter = this.onEnter.bind(this)
        this._raf = null
        this.element.addEventListener('mousemove', this.boundMove, { passive: true })
        this.element.addEventListener('pointermove', this.boundMove, { passive: true })
        this.element.addEventListener('mouseenter', this.boundEnter, { passive: true })
        this.element.addEventListener('mouseleave', this.boundLeave, { passive: true })

    }

    disconnect() {
        this.element.removeEventListener('mousemove', this.boundMove)
        this.element.removeEventListener('pointermove', this.boundMove)
        this.element.removeEventListener('mouseenter', this.boundEnter)
        this.element.removeEventListener('mouseleave', this.boundLeave)
        this._raf && cancelAnimationFrame(this._raf)
    }

    onMove(event) {
        if (this._raf) return
        this._raf = requestAnimationFrame(() => {
            const rect = this.element.getBoundingClientRect()
            const x = ((event.clientX - rect.left) / rect.width) * 100
            const y = ((event.clientY - rect.top) / rect.height) * 100

            // Opposite end of mouse position: invert x/y
            const invX = 100 - x
            const invY = 100 - y

            this.element.style.setProperty('--shine-x', invX + '%')
            this.element.style.setProperty('--shine-y', invY + '%')
            this.element.style.setProperty('--shine-opacity', Math.min(1, 0.2 + 0.8 * this.strengthValue))

            this._raf = null
        })
    }

    onEnter() {
        this.element.style.setProperty('--shine-opacity', Math.min(1, 0.2 + 0.8 * this.strengthValue))

    }

    onLeave() {
        this.element.style.setProperty('--shine-opacity', '0')

    }
}


